<script>
  export let reviewerName
  export let defaultSize = '45px'
  export let profileBackground = '#bbb'

  function firstchar (reviewerName) {
    return reviewerName.charAt(0)
  }
</script>

<style>
  :global(._2TERQ) {
    display: block;
    text-align: center;
    text-transform: uppercase;
    font-size: 23px;
    color: #fff;
    border-radius: 50%;
    float: left;
    margin-right: 10px;
  }
</style>

<span
  class="_2TERQ"
  style={`line-height: ${defaultSize}; width: ${defaultSize}; height: ${defaultSize};
  background: ${profileBackground};`}>
  {firstchar(reviewerName)}
</span>
